<td class="mat-mdc-cell">
    <span>{{ rigthName }}</span>
</td>
<td class="mat-mdc-cell" *matCellDef="let element" [ngClass]="{ 'no-action': disabled }">{{ element.attributeName }}</td>
@if (disabled) {
    <td class="mat-mdc-cell mat-mdc-cell-action">
        @if (!!readControlId) {
            <span>
                @if (readControl.value) {
                    <mat-icon class="">done</mat-icon>
                }
            </span>
        }
    </td>
    <td class="mat-mdc-cell mat-mdc-cell-action">
        @if (!!createControlId) {
            <span>
                @if (createControl.value) {
                    <mat-icon class="">done</mat-icon>
                }
            </span>
        }
    </td>
    <td class="mat-mdc-cell mat-mdc-cell-action">
        @if (!!editControlId) {
            <span>
                @if (editControl.value) {
                    <mat-icon class="">done</mat-icon>
                }
            </span>
        }
    </td>
    <td class="mat-mdc-cell mat-mdc-cell-action">
        @if (!!deleteControlId) {
            <span>
                @if (deleteControl.value) {
                    <mat-icon class="">done</mat-icon>
                }
            </span>
        }
    </td>
} @else {
    <td class="mat-mdc-cell mat-mdc-cell-action">
        @if (!!readControlId && readControlAllowed) {
            <div class="checkbox-editor">
                <mat-checkbox class="accent-button" [formControl]="readControl" (change)="checkboxChanged(readControlId, $event)"></mat-checkbox>
            </div>
        }
    </td>
    <td class="mat-mdc-cell mat-mdc-cell-action">
        @if (!!createControlId && createControlAllowed) {
            <div class="checkbox-editor">
                <mat-checkbox class="accent-button" [formControl]="createControl" (change)="checkboxChanged(createControlId, $event)"></mat-checkbox>
            </div>
        }
    </td>
    <td class="mat-mdc-cell mat-mdc-cell-action">
        @if (!!editControlId && editControlAllowed) {
            <div class="checkbox-editor">
                <mat-checkbox class="accent-button" [formControl]="editControl" (change)="checkboxChanged(editControlId, $event)"></mat-checkbox>
            </div>
        }
    </td>
    <td class="mat-mdc-cell mat-mdc-cell-action">
        @if (!!deleteControlId && deleteControlAllowed) {
            <div class="checkbox-editor">
                <mat-checkbox class="accent-button" [formControl]="deleteControl" (change)="checkboxChanged(deleteControlId, $event)"></mat-checkbox>
            </div>
        }
    </td>
}
